import React, { useEffect, useState } from "react";
import "../../css/ShopDashboardScreen.css";
import AdminOfferItem from "../../components/adminDashboard/AdminOfferItem";
import BottomNav from "../../components/BottomNav";
import { useNavigate } from "react-router-dom";
import { getShopDetailsFromLocalStorage } from "../../localstorage";
import { fetchShopOffers } from "../../apiIntegration/getOfferDataFromFirebase";
import { deleteOfferFromFirebase } from "../../apiIntegration/deleteOfferFromFirebase";
import { BlinkBlur } from "react-loading-indicators";

const Welcome = ({ shopDetails }) => {
	return (
		<div className="px-3">
			<h3>
				Welcome,{" "}
				{shopDetails?.shopName?.charAt(0).toUpperCase() +
					shopDetails?.shopName?.slice(1)}
			</h3>
			<p className="text-muted">
				Here is how your offers are performing today.
			</p>
		</div>
	);
};

const StatsCard = () => {
	return (
		<div className="stats-card m-3 p-3">
			<small>TOTAL VIEWS</small>
			<h1>1.2K</h1>
			<span className="text-success">Business is growing in views</span>
		</div>
	);
};

const SmallStats = ({ offers }) => {
	const activeOffers = offers.filter(
		(item) => item.status === "active",
	).length;

	return (
		<div className="d-flex gap-2 px-3">
			<div className="small-card mr-2">
				<small>ACTIVE OFFERS</small>

				<h2>{activeOffers}</h2>
			</div>

			{/* <div className="small-card">
				<small>TOTAL OFFERS</small>

				<h2 className="text-warning">{offers.length}</h2>
			</div> */}
		</div>
	);
};

const QuickAction = () => {
	const navigate = useNavigate();

	return (
		<div className="px-3 mt-4">
			<small className="text-muted">QUICK ACTIONS</small>

			<button
				onClick={() => navigate("/offer-create-form")}
				className="btn btn-primary w-100 mt-2 create-btn"
			>
				<i className="fas fa-plus mr-2"></i>
				Create New Offer
			</button>
		</div>
	);
};

const OfferList = ({ offers, setOffers }) => {
	const handleDelete = async (offer) => {
		try {
			const confirmDelete = window.confirm("Delete this offer?");

			if (!confirmDelete) return;

			await deleteOfferFromFirebase({
				offerId: offer.offerId,
				shopId: offer.shopId,
				category: offer.category,
				subCategory: offer.subCategory,
				geoHash: offer.geoHash,
			});

			/* ================= REMOVE FROM UI ================= */

			setOffers((prev) =>
				prev.filter((item) => item.offerId !== offer.offerId),
			);

			alert("Offer deleted successfully");
		} catch (error) {
			console.error(error);

			alert("Failed to delete offer");
		}
	};

	if (!offers.length) {
		return (
			<div className="px-3 mt-4 text-center">
				<h6>No Offers Found</h6>

				<p className="text-muted">Create your first offer 🚀</p>
			</div>
		);
	}

	return (
		<div className="px-3 mt-4">
			<div className="d-flex justify-content-between mb-3">
				<small className="text-muted">MY RECENT OFFERS</small>

				{/* <span className="text-primary">{offers.length} Offers</span> */}
			</div>

			{offers.map((offer) => (
				<AdminOfferItem
					key={offer.offerId}
					data={offer}
					onDelete={() => handleDelete(offer)}
				/>
			))}
		</div>
	);
};

export default function ShopDashboardScreen() {
	const [tab, setTab] = useState("offers");
	const [offers, setOffers] = useState([]);
	const [loading, setLoading] = useState(true);
	const shopDetails = getShopDetailsFromLocalStorage();
	const shopId = shopDetails?.shopId;
	const navigate = useNavigate();

	/* ================= FETCH SHOP OFFERS ================= */

	useEffect(() => {
		if (!shopId) {
			navigate("/login-screen", { replace: true });
			return;
		}
		const getOffers = async () => {
			try {
				setLoading(true);

				const data = await fetchShopOffers(shopId);

				data.sort(
					(a, b) => new Date(b.createdAt) - new Date(a.createdAt),
				);

				setOffers(data || []);
			} catch (error) {
				console.error(error);
				setOffers([]);
			} finally {
				setLoading(false);
			}
		};

		if (!shopId) {
			setLoading(false);
			return;
		}

		getOffers();
	}, []);

	return (
		<div className="app">
			<Welcome shopDetails={shopDetails} />
			{/* <StatsCard totalOffers={offers.length} /> */}
			<SmallStats offers={offers} />
			<QuickAction />

			{/* ================= OFFER LIST ================= */}

			{loading ? (
				<div className="text-center mt-5">
					<div className="px-3 mt-5 nearBuSection">
						<BlinkBlur
							color="#494949"
							size="medium"
							text="Loading offers..."
							textColor="#ffffff"
						/>
					</div>
				</div>
			) : (
				<OfferList offers={offers} setOffers={setOffers} />
			)}
			<BottomNav active={tab} setActive={setTab} />
		</div>
	);
}
